import {BarGroupBar} from '@visx/shape/lib/types';
import {ScaleOrdinal} from 'd3';

import {DataFrameRow} from 'data-frames/DataFrameTypes';
import {DataFrameValueAccessor, rowIdAccessor} from 'data-frames/util/createAccessors';
import {VisxAxisScale, VisxScaleType} from 'ui-library/charting/internals/VisxUtilityTypes';
import {LabelCompatibleType} from 'ui-library/charting/Types';
import {JSONValue} from 'util/Types';

export interface BarChartAccessors {
  xAccessor: DataFrameValueAccessor<string>;
  yAccessor: DataFrameValueAccessor<number>;
  rowIdAccessor: typeof rowIdAccessor;
  seriesAccessor: DataFrameValueAccessor<string>;
  errorValueAccessor?: DataFrameValueAccessor<number>;
}

export interface BarChartContentProps {
  accessors: BarChartAccessors;
  barGroupDicts: BarGroupDicts;
  barGroupRowMaps: BarGroupRowMaps;
  chartWidth: number;
  chartHeight: number;
  handleOnHoverBar: (hoverInfo: BarChartHoverInfo | null) => void;
  highlightedSeries: LabelCompatibleType | null;
  hoveredRow: DataFrameRow | null;
  isSeriesEnabled: boolean;
  seriesUniqueValues: Array<string>;
  scales: BarChartScales;
}

export interface BarChartHoverInfo {
  barProperties: Pick<BarGroupBar<string>, 'color' | 'height' | 'width' | 'x' | 'y'>;
  barGroupInfo: {
    x: number;
  };
  dataFrameRow: DataFrameRow;
}

export interface BarChartScales {
  colorScale: ScaleOrdinal<string, string>;
  xScale: VisxAxisScale<VisxScaleType.BAND>;
  yScale: VisxAxisScale<VisxScaleType.LINEAR> | VisxAxisScale<VisxScaleType.LOG>;
}

export enum BarChartType {
  GROUPED = 'GROUPED',
  STACKED = 'STACKED',
}

export type BarGroupRowMaps = Array<{groupName: string; rowMap: Record<string, DataFrameRow>}>;
export type BarGroupDicts = Array<Record<string, JSONValue>>;
